import axios, { AxiosResponse } from 'axios';
import { Invitacion, GrupoInvitacion, UsuarioEmpresa, ArchivoGrupoInvitacion } from './suite.interfaces';
import { CommonService } from './common.services';

export class InvitacionService extends CommonService {

  async findGruposInvitacionesBy(usuarioEmpresa:UsuarioEmpresa): Promise<GrupoInvitacion[]> {
    try {
      const response: AxiosResponse<GrupoInvitacion[]> = await axios.get(super.getServerUrl() + '/mobile/findGruposInvitacionesBy?idUsuarioEmpresa=' + usuarioEmpresa.id, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findGrupoInvitacionById(evento:number, idGrupoInvitaciones:number): Promise<GrupoInvitacion> {
    try {
      const response: AxiosResponse<GrupoInvitacion> = await axios.get(super.getServerUrl() + '/mobile/findGrupoInvitacionById?evento=' + evento + '&id=' + idGrupoInvitaciones, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findInvitacionUnicaBy(evento: number, idGrupoInvitacion: number): Promise<Invitacion> {
    try {      
      const response: AxiosResponse<Invitacion> = await axios.get(super.getServerUrl() + '/mobile/findInvitacionUnicaBy?evento=' + evento + '&idGrupoInvitacion=' + idGrupoInvitacion, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findInvitacionById(evento: number, id: number): Promise<Invitacion> {
    try {      
      const response: AxiosResponse<Invitacion> = await axios.get(super.getServerUrl() + '/mobile/findInvitacionById?evento=' + evento + '&id=' + id, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async liberarInvitacionBy(evento: number, idAcreditado: number): Promise<String> {
    try {
      const response: AxiosResponse<String> = await axios.get(super.getServerUrl() + '/mobile/liberarInvitacionBy?evento=' + evento + '&idAcreditado=' + idAcreditado, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findInvitacionBy(evento: number, codigoInvitacion: string): Promise<Invitacion> {
    try {      
      const response: AxiosResponse<Invitacion> = await axios.get(super.getServerUrl() + '/mobile/findInvitacionBy?evento=' + evento + '&codigoInvitacion=' + codigoInvitacion, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async findArchivosGruposInvitacionesBy(idGrupoInvitacion: number): Promise<ArchivoGrupoInvitacion[]> {
    try {      
      const response: AxiosResponse<ArchivoGrupoInvitacion[]> = await axios.get(super.getServerUrl() + '/mobile/findArchivosGruposInvitacionesBy?idGrupoInvitacion=' + idGrupoInvitacion, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }
  
  async subirArchivo(archivoGrupoInvitacion:ArchivoGrupoInvitacion) {
    try {
      const response: AxiosResponse<UsuarioEmpresa> = await axios.post(super.getServerUrl() + '/mobile/subirArchivo?', archivoGrupoInvitacion, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  async removeFile(archivoGrupoInvitacion:ArchivoGrupoInvitacion) {
    try {
      const response: AxiosResponse<UsuarioEmpresa> = await axios.get(super.getServerUrl() + '/mobile/removeFile?idArchivoGrupoInvitacion=' +  archivoGrupoInvitacion.id, { headers: {"Authorization": this.token, "Client-ID" : this.clientId }});
      return response.data;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  getReporteUrl(evento:number, idGrupoInvitacion:number) : string {
    try {
      return super.getServerUrl() + '/mobile/getReporte?evento=' + evento + '&idGrupoInvitacion=' + idGrupoInvitacion;
    } catch (error) {
      throw super.manageError(error);
    }
  }

  getFileUrl(idArchivoGrupoInvitacion:number) : string {
    try {
      return super.getServerUrl() + '/mobile/downloadFile?idArchivoGrupoInvitacion=' + idArchivoGrupoInvitacion;
    } catch (error) {
      throw super.manageError(error);
    }
  }
}

